import React from 'react';
import styled from 'styled-components/macro';

import Delegation from './Staking/Delegation';
import ValidatorSidebar from './Staking/ValidatorSidebar';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 45px;

  height: 100%;
`;

const Sidebar = styled.div`
  padding-left: 45px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.bg4};
`;

export function NFTsTab() {
  return (
    <Layout>
      <Delegation type="delegate" />
      <Sidebar>
        <ValidatorSidebar />
      </Sidebar>
    </Layout>
  );
}
